import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

/**
 * Parse environment variables including custom Field Report specific variables
 */
export const parseFieldReportEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Field Report specific variables
  return {
    ...baseEnvironment,
    PRE_SALES_REBUILD_DONE: config['PRE_SALES_REBUILD_DONE'] === 'true',
  };
};
